import React, { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Footer from '../Pages/Footer';
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../config/api';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  // 🔹 On récupère le token passé dans l'URL
  const { token } = useParams();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);

  if (password !== password2) {
    setError("Les mots de passe ne correspondent pas");
    return;
  }

  setLoading(true);

  try {
    const res = await fetch(`${API_URL}/user/reset-password/${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password, password2 }), // ✅ envoyer les deux
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.message || 'Erreur lors de la réinitialisation');
      setLoading(false);
      return;
    }

    toast.success('Mot de passe réinitialisé avec succès !', { duration: 4000 });
    navigate('/login');

  } catch (err) {
    setError('Erreur serveur');
  } finally {
    setLoading(false);
  }
};

// console.log('Token reçu:', token);
// console.log('Date actuelle:', Date.now());
  return (
    <>
      <div className="reset-page">
        <Toaster position="top-right" reverseOrder={false} />

        <div className="reset-container">
          <div className="reset-card">
            <h2 className="reset-header">Réinitialiser le mot de passe</h2>
            {error && <p className="reset-error">{error}</p>}

            <form onSubmit={handleSubmit} className="reset-form">
              <input
                type="password"
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
              <input
                type="password"
                placeholder="Confirmer le mot de passe"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                required
                disabled={loading}
              />
              <button type="submit" className="btn-reset" disabled={loading}>
                {loading ? 'Réinitialisation...' : 'Réinitialiser'}
              </button>
            </form>

            <div className="reset-footer">
              <p>
                Retour à la <Link to="/login" className="link-login">connexion</Link>
              </p>
            </div>
          </div>
        </div>

        {/* CSS intégré */}
        <style jsx>{`
          .reset-page { min-height: 70vh; display: flex; justify-content: center; padding: 2rem; }
          .reset-container { width: 100%; max-width: 400px; }
          .reset-card { background: #fff; padding: 2rem; border-radius: 1rem; box-shadow: 0 10px 25px rgba(0,0,0,0.1); display: flex; flex-direction: column; gap: 1rem; }
          .reset-header { text-align: center; font-size: 1.8rem; font-weight: 700; color: #333; margin-bottom: 1rem; }
          .reset-error { color: #ff4d4f; text-align: center; font-weight: 500; }
          .reset-form input { width: 100%; padding: 0.75rem 1rem; border: 1px solid #ddd; border-radius: 0.75rem; font-size: 1rem; margin-bottom: 1rem; outline: none; transition: all 0.2s ease; }
          .reset-form input:focus { border-color: #667eea; box-shadow: 0 0 0 2px rgba(102,126,234,0.2); }
          .btn-reset { width: 100%; padding: 0.75rem; background: #667eea; color: #fff; font-weight: 600; border: none; border-radius: 0.75rem; cursor: pointer; transition: all 0.2s ease; }
          .btn-reset:hover { background: #5563d6; }
          .reset-footer { text-align: center; margin-top: 1rem; }
          .link-login { color: #667eea; font-weight: 600; text-decoration: none; }
          .link-login:hover { text-decoration: underline; }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

export default ResetPassword;